import { render, staticRenderFns } from "./ContentPreviewEdit.vue?vue&type=template&id=35b39714&scoped=true&"
import script from "./ContentPreviewEdit.vue?vue&type=script&lang=js&"
export * from "./ContentPreviewEdit.vue?vue&type=script&lang=js&"
import style0 from "./ContentPreviewEdit.vue?vue&type=style&index=0&id=35b39714&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b39714",
  null
  
)

export default component.exports